module.exports = __webpack_public_path__ + "img/baijiahao.df5f48d6.jpeg";